export const constants = {
    ADMIN_GLOBAL_USERS: 'LDAP-AMW-OKTA.AcademyAdmin-Global-Users' 
}